module.exports = __webpack_public_path__ + "media/images/front/bg_case_header_01-6975e7be663da2a8c7968c80195ef80c.jpg";